import { Spinner } from '~/components/ui/common/Spinner';

export const InitialLoadingScreen = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'var(--surface-ground)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div className="flex align-items-center gap-2">
        <Spinner size={16} />
        <span>Loading application...</span>
      </div>
    </div>
  );
};
